<template>
  <div class="d-flex justify-content-center d-flex align-items-center m-0 mx-2 text-center">
    <Pagination
      v-model="page"
      :records="total"
      :per-page="perPage"
      :options="options"
      @paginate="goToPage"
    />
  </div>
</template>

<script>
import config from '@/config'
import Pagination from 'vue-pagination-2'

export default {
  name: 'OpportunityListPagination',
  components: { Pagination },
  data () {
    return {
      page: 1,
      options: {
        chunk: 25,
        edgeNavigation: true,
        theme: 'bootstrap4',
        texts: {
          count: ''
        }
      }
    }
  },
  computed: {
    currentp () {
      return this.currentPage
    }
  },
  props: {
    total: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: config.opportunityList.pagination.byPage
    },
    currentPage: {
      type: Number,
      default: 0
    }
  },
  methods: {
    cleanPages () {
      this.page = 1
    },
    goToPage (page) {
      this.$emit('onPage', page - 1)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .page-link {
  font-weight: 800;
  color: #00a7cb !important;
}

::v-deep .page-item.active .page-link {
  color: #fff !important;
  pointer-events: none;
  cursor: auto;
  background-color: #00a7cb;
  border-color: #00a7cb;
}

::v-deep .page-item.disabled .page-link {
  color: #6c757d !important;
}
</style>
